export { ViewDetailTab } from './ViewDetailTab';
